import React, { useMemo } from 'react';

import Table from 'components/common/Table';

import { adminWarehouseApi } from 'api';
import { useUserContext } from 'providers/UserProvider';

import { getAdminWarehouseListColumns } from 'constants/admin/warehouse';

const Warehouse = () => {
  const { selectedTenant, selectedWarehouse } = useUserContext();

  const tenant = selectedTenant?.domains?.[0]?.domain;
  const warehouse = selectedWarehouse?.domain;

  const columns = useMemo(() => {
    return getAdminWarehouseListColumns(tenant, warehouse);
  }, [tenant, warehouse]);

  return (
    <Table title="Warehouse" apiService={adminWarehouseApi} columns={columns} />
  );
};

export default Warehouse;
